export const API_BASE_URL = "https://graph.facebook.com/v23.0";

export const GENDER = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
];

export const NAMEPREFIX = [
  { label: "MR.", value: "MR." },
  { label: "MRS.", value: "MRS." },
  { label: "MS.", value: "MS." },
  { label: "DR.", value: "DR." },
];
export const CONTACTTYPE = [
  { label: "B2B", value: "B2B" },
  { label: "B2C", value: "B2C" },
];
export const LEADTYPE = [
  { label: "B2B", value: "B2B" },
  { label: "B2C", value: "B2C" },
];
export const INQUIRYTYPE = [
  { label: "B2B", value: "B2B" },
  { label: "B2C", value: "B2C" },
];

export const SECTORTYPE = [
  { label: "DOMESTIC", value: "DOMESTIC" },
  { label: "INTERNATIONAL", value: "INTERNATIONAL" },
];

export const SEASON = [
  { label: "Jan-Feb-Mar", value: "Jan-Feb-Mar" },
  { label: "Apr-May-Jun", value: "Apr-May-Jun" },
  { label: "Jul-Aug-Sep", value: "Jul-Aug-Sep" },
  { label: "Oct-Nov-Dec", value: "Oct-Nov-Dec" },
];

export const BOOKINGSTATUSHOTEL = [
  { label: "Draft", value: "DRAFT" },
  { label: "Pending Confirmation", value: "PENDING CONFIRMATION" },
  { label: "Confirmed", value: "CONFIRMED" },
];

export const BOOKINGSTATUS = [
  { label: "Confirmed", value: "Confirmed" },
  { label: "Pending", value: "PENDING" },
  { label: "Cancelled", value: "CANCELLED" },
];

export const GSTTAXSTATUS = [
  { label: "Paid ", value: "Paid " },
  { label: "Pending", value: "Pending" },
];

export const STATUSARRAY = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const VISA_TYPE = [
  { label: "Visa Free", value: "Visa Free" },
  { label: "Visa On Arrival", value: "Visa On Arrival" },
];

export const UniversalMarkupType = [
  { label: "Percentage (%)", value: 1 },
  { label: "Flat", value: 2 },
];

export const TRAVELTYPE = [
  { label: "TOUR", value: "TOUR" },
  { label: "PACKAGE", value: "PACKAGE" },
];

export const TRAVELTYPEALL = [
  { label: "TOUR", value: 1 },
  { label: "PACKAGE", value: 2 },
  { label: "ALL", value: 3 },
];

export const JOURNEYTYPE = [
  { label: "DEPARTURE", value: "DEPARTURE" },
  { label: "RETURN", value: "RETURN" },
];

export const RATETYPE = [
  { label: "PER PERSON", value: "PER PERSON" },
  { label: "PER COUPLE", value: "PER COUPLE" },
];

export const GSTRATE = [
  { label: "5%", value: 5 },
  { label: "12%", value: 12 },
  { label: "18%", value: 18 },
];

export const CURRENCY = [
  { label: "INR", value: 1 },
  { label: "USD", value: 2 },
];

export const VEHICLESHARINGPAX = [
  { label: "2 PAX", value: 1 },
  { label: "3 PAX", value: 2 },
  { label: "4 PAX", value: 3 },
  { label: "5 PAX", value: 4 },
  { label: "SHARING", value: 5 },
];

export const VEHICLESHARING = [
  { label: "SHARING", value: "SHARING" },
  { label: "SEPARATE", value: "SEPARATE" },
];

export const STARRATING = [
  { label: "1 STAR", value: "1 STAR" },
  { label: "2 STAR", value: "2 STAR" },
  { label: "3 STAR", value: "3 STAR" },
  { label: "4 STAR", value: "4 STAR" },
  { label: "5 STAR", value: "5 STAR" },
];

export const CONTACTSORTTYPE = [
  { label: "Created On Desc", value: "CreatedOnDesc" },
  { label: "Created On Acs", value: "CreatedOnAcs" },
  { label: "Name Desc", value: "NameDesc" },
  { label: "Name Asc", value: "NameAsc" },
];

export const PAYMENTFOR = [
  { label: "TOUR", value: "TOUR" },
  { label: "PACKAGE", value: "PACKAGE" },
  { label: "TICKET", value: "TICKET" },
];

export const CALENDERDAYS = [
  { label: "Sun", value: "Sun" },
  { label: "Mon", value: "Mon" },
  { label: "Tue", value: "Tue" },
  { label: "Wed", value: "Wed" },
  { label: "Thu", value: "Thu" },
  { label: "Fri", value: "Fri" },
  { label: "Sat", value: "Sat" },
];

export const BOOLEAN = [
  { label: "Yes", value: 1 },
  { label: "No", value: 2 },
];

export const SEASONTYPE = [
  { label: "Winter", value: "Winter" },
  { label: "Summer", value: "Summer" },
  { label: "Monsoon", value: "Monsoon" },
  { label: "Autumn", value: "Autumn" },
];

export const PAYMENTTYPE = [
  { label: "CASH", value: "CASH" },
  { label: "CREDIT CARD", value: "CREDIT CARD" },
  { label: "CHEQUE", value: "CHEQUE" },
  { label: "NEFT / IMPS", value: "NEFT / IMPS" },
  { label: "UPI", value: "UPI" },
  { label: "BANK DEPOSIT", value: "BANK DEPOSIT" },
  // { label: "CREDIT NOTE", value: "CREDIT NOTE" },
];

export const UPITYPE = [
  { label: "Paytm", value: "PAYTM" },
  { label: "PhonePay", value: "PHONEPAY" },
  { label: "GooglePay", value: "GOOGLEPAY" },
];

export const ONWARDJOURNEYTYPE = [
  { label: "ONE WAY", value: "ONE WAY" },
  { label: "TWO WAY", value: "TWO WAY" },
  { label: "MULTI WAY", value: "MULTI WAY" },
];

export const DATETYPE = [
  { label: "Booking Date", value: 1 },
  { label: "Travel Date", value: 2 },
];

export const CUSTOMERREPORTDATETYPE = [
  { label: "Booking Date", value: 1 },
  { label: "Travel Date", value: 2 },
  { label: "Tour Date", value: 3 },
];

export const REVENUEDATETYPE = [
  { label: "Confirmation Date", value: "ConfirmationDate" },
  { label: "Booking Date", value: "BookingDate" },
];

export const USERPERFORMANCEDATETYPE = [
  { label: "Inquiry Date", value: "InquiryDate" },
  { label: "Booking Date", value: "BookingDate" },
];

export const FESTIVALS = [
  { value: 1, label: "Rakshabandhan Day" },
  { value: 3, label: "Mahashivratri" },
  { value: 4, label: "Dhanteras" },
  { value: 5, label: "Diwali" },
  { value: 6, label: "Holi" },
  { value: 7, label: "Christmas" },
  { value: 8, label: "Makar Sankranti" },
  { value: 10, label: "New Year" },
];

export const CNBAGEArray = [
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
];

export const PRIORITY = [
  { value: "Hot", label: "Hot" },
  { value: "Warm", label: "Warm" },
  { value: "Cold", label: "Cold" },
];

export const MARITALSTATUS = [
  { value: "N/A", label: "N/A" },
  { value: "Married", label: "Married" },
  { value: "Unmarried", label: "Unmarried" },
];

export const CUSTOMERCATEGORY = [
  { value: "Platinum", label: "Platinum" },
  { value: "Gold", label: "Gold" },
  { value: "Silver", label: "Silver" },
];

export const TagStars = [
  { value: 1, label: "1 Star" },
  { value: 2, label: "2 Star" },
  { value: 3, label: "3 Star" },
  { value: 4, label: "4 Star" },
  { value: 5, label: "5 Star" },
];

export const INQUIRYQUERIES = [
  { value: "PACKAGE", label: "Package" },
  { value: "FLIGHT", label: "Flight" },
  { value: "VISA", label: "Visa" },
  { value: "HOTEL", label: "Hotel" },
];

export const INQUIRYSTATUS = [
  { value: "ALL", label: "All" },
  { value: "OPEN", label: "Open" },
  { value: "CLOSED", label: "Closed" },
];

export const QUOTATIONSTATUS = [
  { value: "Sent", label: "Sent" },
  { value: "REVISED", label: "Revised" },
  { value: "ACCEPTED", label: "Accepted" },
  { value: "REJECTED", label: "Rejected" },
];

export const FLIGHTQUOTETYPE = [
  { value: 1, label: "Text Based" },
  { value: 2, label: "Detailed" },
];

export const BOOKINGTYPEARRAY = [
  { value: "TourBooking", label: "Tour Booking" },
  { value: "FITBooking", label: "FIT Booking" },
];
``;

export const STAGETYPE = [
  { value: "INQUIRY", label: "INQUIRY" },
  { value: "LEAD", label: "LEAD" },
];

export const PAYMENTTYPES = [
  { value: "Yearly", label: "Yearly" },
  { value: "Half Yearly", label: "Half Yearly" },
  { value: "Quarterly", label: "Quarterly" },
  { value: "Monthly", label: "Monthly" },
];

export const QUERYTYPES = [
  { value: "FIT(Normal)", label: "FIT (Normal)" },
  { value: "GIT(Group)", label: "GIT (Group)" },
];

export const HOTELPREFERENCE = [
  { value: "1 Star", label: "1" },
  { value: "2 Star", label: "2" },
  { value: "3 Star", label: "3" },
  { value: "4 Star", label: "4" },
  { value: "5 Star", label: "5" },
];

export const TRIPTYPE = [
  { label: "One Way", value: "One Way" },
  { label: "Two Way", value: "Two Way" },
  // { label: "Multi City", value: "Multi City" },
];

export const AIRLINESTOPS = [
  { label: "Non Stop", value: "0" },
  { label: "1 Stop", value: "1" },
  { label: "2 & More", value: "2" },
];

export const FOLLOWUPSTATUS = [
  // { value: "NA", label: "No Status" },
  { value: "Hot", label: "Hot" },
  { value: "Warm", label: "Warm" },
  { value: "Cold", label: "Cold" },
];

export const VISAENTRYTYPE = [
  { value: "Single Entry", label: "Single Entry" },
  { value: "Multi Entry", label: "Multi Entry" },
  { value: "Double Entry", label: "Double Entry" },
  { value: "Consulate Discretion", label: "Consulate Discretion" },
];

export const PAXCOUNT = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
];

export const PAXCOUNTINNUMBER = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
];

export const MAPPING_FIELDS = [
  {
    name: "FileName",
    label: "Name",
    placeholder: "Facebook field for Name",
  },
  {
    name: "MobileNo",
    label: "Mobile No",
    placeholder: "Facebook field for Mobile",
  },
  {
    name: "EmailID",
    label: "Email ID",
    placeholder: "Facebook field for Email",
  },
  {
    name: "PackageName",
    label: "Package Name",
    placeholder: "Facebook field for Package",
  },
  {
    name: "Destination",
    label: "Destination",
    placeholder: "Facebook field for Destination",
  },
  {
    name: "ViaRoute",
    label: "Via Route",
    placeholder: "Facebook field for Via Route",
  },
  {
    name: "TravelDate",
    label: "Travel Date",
    placeholder: "Facebook field for Travel Date",
  },
  {
    name: "TravelMonth",
    label: "Travel Month",
    placeholder: "Facebook field for Travel Month",
  },
  {
    name: "TourType",
    label: "Tour Type",
    placeholder: "Facebook field for Tour Type",
  },
  {
    name: "TotalPax",
    label: "Total Pax",
    placeholder: "Facebook field for Total Pax",
  },
  {
    name: "Adult",
    label: "Adults",
    placeholder: "Facebook field for Adults",
  },
  {
    name: "Child",
    label: "Children",
    placeholder: "Facebook field for Children",
  },
  {
    name: "Duration",
    label: "Duration",
    placeholder: "Facebook field for Duration",
  },
  {
    name: "TotalRoom",
    label: "Total Room",
    placeholder: "Facebook field for Total Room",
  },
  {
    name: "HotelName",
    label: "Hotel Name",
    placeholder: "Facebook field for Hotel",
  },
  {
    name: "IsCustomizedPackage",
    label: "Is Customized Package",
    placeholder: "Facebook field for Is Customized Package",
  },
];

export const TRIGGERMODULE = [
  { value: "Lead", label: "Lead" },
  { value: "Inquiry", label: "Inquiry" },
  { value: "Quotation", label: "Quotation" },
  { value: "Booking", label: "Booking" },
];

export const TRIGGEROPERATION = [
  { value: "Inserted", label: "Inserted" },
  { value: "Updated", label: "Updated" },
  { value: "Deleted", label: "Deleted" },
  { value: "Assign", label: "Assign" },
];

export const TRIGGERWATO = [
  { value: "Lead", label: "Lead" },
  { value: "Executive", label: "Executive" },
];

export const DISC_TYPE = [
  { label: "Percentage", value: "PER" },
  { label: "Rupees", value: "RS" },
];

export const PROMO_TYPE = [
  { label: "Auto", value: "Auto" },
  { label: "Manual", value: "Manual" },
];

export type ISelectionType = {
  value: number | string;
  label: string;
};

export const INSERT_OPT_TYPE = 1;
export const EDIT_OPT_TYPE = 2;
export const DELETE_OPT_TYPE = 3;
export const GET_BY_GUID_OPT_TYPE = 4;
export const GET_ALL_ACTIVE_WITH_FILTER_OPT_TYPE = 5;
export const GET_ALL_OPT_TYPE = 6;
export const ACTIVE_INACTIVE_OPT_TYPE = 7;

export const DRAWER_WIDTH = 400;

export const INSERT_ACCESS = "1";
export const EDIT_ACCESS = "2";
export const DELETE_ACCESS = "3";
export const PDF_DOWNLOAD_ACCESS = "4";
export const EXCEL_EXPORT_ACCESS = "5";
export const PRINT_ACCESS = "6";

export const DateRangeFilter = [
  { value: 1, label: "Today" },
  { value: 2, label: "Yesterday" },
  { value: 3, label: "This Week" },
  { value: 4, label: "Last 30 Days" },
  { value: 5, label: "This Month" },
  { value: 6, label: "Custom" },
];
